import { render, staticRenderFns } from "./RoyaltyAnalyticsList.vue?vue&type=template&id=159b735f&scoped=true&"
import script from "./RoyaltyAnalyticsList.vue?vue&type=script&lang=js&"
export * from "./RoyaltyAnalyticsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159b735f",
  null
  
)

export default component.exports